// Module
var code = `<ex-mono-occurrence-ecran mono-occurrence-options="vm.monoOccurrenceOptions"> <ex-mono-occurrence-ecran-bas> <ex-card-multi-advanced ex-bloc="dti" lbl-titre="LBL_BLC_DTI" opened="true" multi-occurrence-options="vm.dtiMultiOccurrenceOptions"> </ex-card-multi-advanced> </ex-mono-occurrence-ecran-bas> </ex-mono-occurrence-ecran>`;
// Exports
module.exports = code;